import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0 ps-5" }
const _hoisted_3 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_4 = { class: "card-title m-0" }
const _hoisted_5 = { class: "fw-bolder m-0" }
const _hoisted_6 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_7 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_8 = { class: "success d-flex bg-light-success rounded border-success border border-dashed p-6" }
const _hoisted_9 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_10 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = { class: "fs-6 text-gray-600" }
const _hoisted_13 = { class: "card-body border-top p-9" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-300px" }, "Description"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Submitted"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Actions")
  ])
], -1)
const _hoisted_17 = ["onclick"]
const _hoisted_18 = {
  key: 0,
  fill: "rgba(11, 78, 208, 1)",
  width: "20px",
  height: "20px",
  viewBox: "0 0 32 32",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("title", null, "Download", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 16q0 2.912 1.824 5.088t4.576 2.752q0.032 0 0.032-0.032v-0.064t0.032-0.032q0.544-1.344 1.344-2.176t2.208-1.184v-2.336q0-2.496 1.728-4.256t4.256-1.76 4.256 1.76 1.76 4.256v2.336q1.376 0.384 2.176 1.216t1.344 2.144l0.096 0.288h0.384q2.464 0 4.224-1.76t1.76-4.224v-2.016q0-2.464-1.76-4.224t-4.224-1.76q-0.096 0-0.32 0.032 0.32-1.152 0.32-2.048 0-3.296-2.368-5.632t-5.632-2.368q-2.88 0-5.056 1.824t-2.784 4.544q-1.152-0.352-2.176-0.352-3.296 0-5.664 2.336t-2.336 5.664v1.984zM10.016 25.824q-0.096 0.928 0.576 1.6l4 4q0.576 0.576 1.408 0.576t1.408-0.576l4-4q0.672-0.672 0.608-1.6-0.064-0.32-0.16-0.576-0.224-0.576-0.736-0.896t-1.12-0.352h-1.984v-5.984q0-0.832-0.608-1.408t-1.408-0.608-1.408 0.608-0.576 1.408v5.984h-2.016q-0.608 0-1.12 0.352t-0.736 0.896q-0.096 0.288-0.128 0.576z",
  stroke: "rgba(11, 78, 208, 1)"
}, null, -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 0,
  fill: "rgba(11, 78, 208, 1)",
  width: "20px",
  height: "20px",
  viewBox: "0 0 32 32",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("title", null, "Download", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 16q0 2.912 1.824 5.088t4.576 2.752q0.032 0 0.032-0.032v-0.064t0.032-0.032q0.544-1.344 1.344-2.176t2.208-1.184v-2.336q0-2.496 1.728-4.256t4.256-1.76 4.256 1.76 1.76 4.256v2.336q1.376 0.384 2.176 1.216t1.344 2.144l0.096 0.288h0.384q2.464 0 4.224-1.76t1.76-4.224v-2.016q0-2.464-1.76-4.224t-4.224-1.76q-0.096 0-0.32 0.032 0.32-1.152 0.32-2.048 0-3.296-2.368-5.632t-5.632-2.368q-2.88 0-5.056 1.824t-2.784 4.544q-1.152-0.352-2.176-0.352-3.296 0-5.664 2.336t-2.336 5.664v1.984zM10.016 25.824q-0.096 0.928 0.576 1.6l4 4q0.576 0.576 1.408 0.576t1.408-0.576l4-4q0.672-0.672 0.608-1.6-0.064-0.32-0.16-0.576-0.224-0.576-0.736-0.896t-1.12-0.352h-1.984v-5.984q0-0.832-0.608-1.408t-1.408-0.608-1.408 0.608-0.576 1.408v5.984h-2.016q-0.608 0-1.12 0.352t-0.736 0.896q-0.096 0.288-0.128 0.576z",
  stroke: "rgba(11, 78, 208, 1)"
}, null, -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  width: "20px",
  height: "20px",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("title", null, "Visit", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14 12C14 14.7614 11.7614 17 9 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H7.5M10 12C10 9.23858 12.2386 7 15 7H17C19.7614 7 22 9.23858 22 12C22 14.7614 19.7614 17 17 17H16.5",
  stroke: "rgba(11, 78, 208, 1)",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = ["onclick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20px",
  height: "20px",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "Delete"),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 7V18C6 19.1046 6.89543 20 8 20H16C17.1046 20 18 19.1046 18 18V7M6 7H5M6 7H8M18 7H19M18 7H16M10 11V16M14 11V16M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7M8 7H16",
    stroke: "rgba(11, 78, 208, 1)",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.titleTable), 1)
        ])
      ]),
      _createTextVNode(" > ")
    ]),
    _createElementVNode("div", _hoisted_6, [
      (
          _ctx.currentIrbReviewNote != null &&
          _ctx.currentIrbReviewNote.note != '' &&
          false
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen043.svg" })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, "Note: " + _toDisplayString(_ctx.currentIrbReviewNote.note), 1)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentDocumentsResponse.data, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.name), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.moment(item.createdDate)), 1),
                  _createElementVNode("td", null, [
                    (item.data != null && item.data != ``)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onclick: () => _ctx.downloadFile(item),
                          target: "_blank",
                          class: "",
                          style: {"cursor":"pointer"},
                          type: "download"
                        }, [
                          (item.type != `link`)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_21))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true),
                    (item.url != null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: item.type != `link` ? _ctx.getURL(item.url) : item.url,
                          target: "_blank",
                          type: "download",
                          class: ""
                        }, [
                          (item.type != `link`)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_26))
                            : _createCommentVNode("", true),
                          (item.type == `link`)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_27, _hoisted_30))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_22))
                      : _createCommentVNode("", true),
                    (_ctx.hiddeDeleteDocument == false)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          onclick: 
                        () =>
                          _ctx.deleteFile(
                            item.irbApplicationId,
                            item.id,
                            item.name,
                            _ctx.classificationDoc
                          )
                      ,
                          target: "_blank",
                          class: "",
                          style: {"cursor":"pointer"}
                        }, _hoisted_33, 8, _hoisted_31))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}